import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-dlg-password-expiration-warning',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatIconModule
  ],
  templateUrl: './dlg-password-expiration-warning.component.html',
  styleUrl: './dlg-password-expiration-warning.component.scss'
})
export class DlgPasswordExpirationWarningComponent {

  daysRemaining?: number;
  readonly data = inject<any>(MAT_DIALOG_DATA);

  constructor() {
    if (this.data) {
      this.daysRemaining = this.data.daysRemaining;
    }
  }
}
